import React from "react";
import { Button } from "@my-scoot/component-library-legacy";
import { getListingUuidFromUrlParam } from "ui/pages/ThankYou/utils";
import { useParams } from "react-router-dom";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";

export const ManageOfferingsBtn = ({
  btnText,
  startIcon: Icon,
  action = () => {},
}) => {
  const isDesktop = useDesktopMediaQuery();

  const { listing_uuid } = useParams();
  const listingId = getListingUuidFromUrlParam() || listing_uuid;
  return (
    <Button
      variant="outlined"
      color="secondary"
      className={`!tw-h-[32px] ${isDesktop ? "!tw-text-[14px]" : ""}`}
      {...(Icon && {
        startIcon: (
          <Icon className={isDesktop ? "tw-w-[18px] tw-h-[18px]" : ""} />
        ),
      })}
      onClick={() => action({ listing_uuid: listingId })}
    >
      {btnText}
    </Button>
  );
};
